<div class="breadcrumb-container">
    <a [routerLink]="labels.backRoute">
        <i class="material-icons">&#xE88A;</i>
        <span>{{labels.currentPageTitle}}</span>
    </a>
</div>